import { createFileRoute } from "@tanstack/react-router";
import { Reveal } from "@/components/site-chrome";
import { PageHero, Eyebrow, WeatherStrip, ProblemStory, WhyChoose, WhoWeServe, SitePhoto, FinalCta } from "@/components/sections";
import { pageHead, breadcrumbLd } from "@/lib/seo";

const TITLE = "About Josh Ginnaty | 406 Mobile Mechanic, Great Falls MT";
const DESC = "406 Mobile Mechanic is owner-operated by Josh Ginnaty, serving Great Falls, MT and across Montana since 2020. Open 7 days, 8AM–9PM.";

export const Route = createFileRoute("/about")({
  head: () => pageHead("/about", TITLE, DESC, [breadcrumbLd([{ name: "Home", path: "/" }, { name: "About", path: "/about" }])]),
  component: AboutPage,
});

function AboutPage() {
  return (
    <main>
      <PageHero
        crumbs={[{ label: "Home", to: "/" }, { label: "About" }]}
        eyebrow="Est. 2020 · Owner-operated"
        title={<>Your Mobile Mechanic in <span className="text-primary">Great Falls, MT</span></>}
        intro="406 Mobile Mechanic is owner-operated by Josh Ginnaty, serving Great Falls and Montana since 2020. When you call, you get the mechanic who actually does the work."
        photo="lettering"
      />
      <div className="relative z-10 -mt-14"><WeatherStrip /></div>
      <ProblemStory />
      <section className="bg-background pb-24">
        <div className="mx-auto grid max-w-7xl items-center gap-10 px-4 sm:px-6 md:grid-cols-2">
          <Reveal>
            <SitePhoto name="towing" sizes="(min-width: 768px) 50vw, 100vw" className="cut-corner aspect-[4/3] w-full object-cover" />
          </Reveal>
          <Reveal>
            <Eyebrow>The work truck</Eyebrow>
            <h2 className="mt-4 text-4xl font-black md:text-5xl">A Shop That Comes to You</h2>
            <p className="mt-5 text-lg text-foreground/85">The work truck carries the tools to diagnose and repair on site, and the trailer handles transport when a job needs it. Rain, sleet, snow, or sunshine — we get the job done.</p>
          </Reveal>
        </div>
      </section>
      <WhyChoose />
      <WhoWeServe />
      <FinalCta />
    </main>
  );
}
